import { throttle } from 'throttle-debounce';

const articleVideo = () => {
  const poster = document.querySelector('[data-article-video-poster]')

  if(!poster) {return}

  const setPoster = () => {
    const posterImage = poster.dataset.articleVideoPoster
    if(!posterImage) {return}
    // remove first to get true height of video
    poster.removeAttribute('poster')
    const sizedPosterImage = posterImage + `c_crop,h_${poster.offsetHeight},w_${poster.offsetWidth}`
    poster.setAttribute('poster', sizedPosterImage)
  }

  window.addEventListener(
    'resize',
    throttle(333, false, () => {
      setPoster();
    })
  );

  poster.addEventListener('loadeddata', () => {
    // fixes race condition, sometimes the js loads after the video, this will fire if the js loads before
    setPoster();
  })
  
  setPoster();
}

const autoPlayOnDesktop = () => {
  let videoIsPlaying = false
  const video = document.querySelector('[data-article-video]')

  if(!video) {return}

  window.addEventListener(
    'scroll',
    throttle(222, false, () => {
      if(videoIsPlaying === false) {
        if(video.getBoundingClientRect().top - video.getBoundingClientRect().height < 150) {
          videoIsPlaying = true
          video.play()
        }
      }
    })
  );
}

export {articleVideo, autoPlayOnDesktop}